/**
 * Exchanges the signed-in user's Cognito token for temporary AWS credentials whose only permission
 * is invoking the chat function. Two plain POSTs; the SDK would be ~200KB for this.
 *
 * Credentials are cached until shortly before expiry, so a conversation costs one exchange.
 */

let cached = null;
const call = async (region, target, body) => {
  const res = await fetch("https://cognito-identity.".concat(region, ".amazonaws.com/"), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': "AWSCognitoIdentityService.".concat(target)
    },
    body: JSON.stringify(body)
  });
  if (!res.ok) throw new Error("cognito-identity ".concat(target, " failed"));
  return res.json();
};
export async function getAwsCredentials(idToken, _ref) {
  let region = _ref.region,
    identityPoolId = _ref.identityPoolId,
    userPoolId = _ref.userPoolId;
  // A minute of headroom: a turn can outlive a credential that expires mid-stream.
  if (cached && cached.token === idToken && cached.expiresAt - 60000 > Date.now()) return cached.credentials;
  const provider = "cognito-idp.".concat(region, ".amazonaws.com/").concat(userPoolId);
  const logins = {
    [provider]: idToken
  };
  const _await$call = await call(region, 'GetId', {
      IdentityPoolId: identityPoolId,
      Logins: logins
    }),
    IdentityId = _await$call.IdentityId;
  const _await$call2 = await call(region, 'GetCredentialsForIdentity', {
      IdentityId,
      Logins: logins
    }),
    c = _await$call2.Credentials;
  const credentials = {
    accessKeyId: c.AccessKeyId,
    secretAccessKey: c.SecretKey,
    sessionToken: c.SessionToken
  };
  cached = {
    credentials,
    expiresAt: c.Expiration * 1000,
    token: idToken
  };
  return credentials;
}

/** Exported for tests and for sign-out, where holding credentials past the session is wrong. */
export const clearCachedCredentials = () => {
  cached = null;
};